import styled from 'styled-components';
import Heading from '../Heading';
const H2 = styled(Heading).attrs({
  tagName: 'h2'
}).withConfig({
  displayName: "H2"
})([""]);
H2.displayName = 'H2';
export default H2;